/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"container_MHM22","wrapperProfile":"wrapperProfile_7azJZ","heading":"heading_D81Vi","wrapperBtn":"wrapperBtn_3nbWH"};